import { SchedulePartialStoreState, SCHEDULE_STATE_KEY } from '../schedule.reducer';

export const getRouteStops = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routeStop.entities;

export const getLoading = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routeStop.loading;

export const getScheduleDays = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routeStop.schedule.days;
export const getDepartures = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routeStop.schedule.departures;
export const getStopsIds = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routeStop.ids;
export const getSelectedId = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routeStop.selectedId;

export const getSelectedDay = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routeStop.selectedDay;
export const getRoutePolyline = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].routeStop.routePolyline;
